//#region src/condition_schema_name.ts
let ConditionSchemaName = /* @__PURE__ */ function(ConditionSchemaName) {
	ConditionSchemaName["None"] = "none";
	ConditionSchemaName["Custom"] = "custom";
	ConditionSchemaName["OneOfMenuSectionsIsSelectedItem"] = "one-of-menu-sections-is-selected-item";
	ConditionSchemaName["OneOfMenuSectionsAreInCart"] = "one-of-menu-sections-are-in-cart";
	ConditionSchemaName["OneOfMenuSectionsAreSelectedItemOrInCart"] = "one-of-menu-sections-are-selected-item-or-in-cart";
	ConditionSchemaName["OneOfMenuItemsIsSelectedItem"] = "one-of-menu-items-is-selected-item";
	ConditionSchemaName["OneOfMenuItemsAreInCart"] = "one-of-menu-items-are-in-cart";
	ConditionSchemaName["OneOfMenuItemsAreSelectedItemOrInCart"] = "one-of-menu-items-are-selected-item-or-in-cart";
	ConditionSchemaName["PreCheckoutPopup"] = "pre-checkout-popup";
	ConditionSchemaName["CartView"] = "cart-view";
	ConditionSchemaName["DietaryRestrictionsApplied"] = "dietary-restrictions-applied";
	ConditionSchemaName["MenuSectionIsRecommendation"] = "menu-section-is-recommendation";
	return ConditionSchemaName;
}({});
//#endregion
export { ConditionSchemaName };

//# sourceMappingURL=condition_schema_name.js.map